import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  background-color: #cdffff;
  border: 1px solid #ccc;
`;


const TableHead = styled.thead`
  background-color: #fff;
  color: #fff
`;

const TableHeadRow = styled.tr`
  background-color: #0052cd;
  border: 1px solid #ccc;
//   background-color: #eee;
`;

const TableHeadCell = styled.th`
  padding: 12px;
  text-align: left;
  border: 1px solid #ccc;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #c0ffff;
  }
  border: 1px solid #ccc;
`;

const TableCell = styled.td`
  padding: 12px;
  text-align: left;
  border: 1px solid #ccc;
`;

function ListTable(props) {
  const list = props.list;
  const rows = list.map((item, index) => (
    <TableRow key={index}>
      <TableCell>{item.name}</TableCell>
      <TableCell>{item.result}</TableCell>
    </TableRow>
  ));

  return (
    <Table>
      <TableHead>
        <TableHeadRow>
          <TableHeadCell>アイテム</TableHeadCell>
          <TableHeadCell>期待値</TableHeadCell>
        </TableHeadRow>
      </TableHead>
      <TableBody>{rows}</TableBody>
    </Table>
  );
}

export default ListTable;
